import { Box, Button, Stack, Typography } from "@mui/material";
import { useAtomValue } from "jotai";
import { baseAtom } from "../../../stores/jotai/base";
import BGStep3 from "../icon/BGStep3";
import { StepperCountBox } from "../common/StepperCountBox";
import { ZOOM_VALID_EMAIL } from "../../../constants";



export default function ConnectCalendar({ googleLogin }) {
  const base = useAtomValue(baseAtom);
  const isEmailValid = ZOOM_VALID_EMAIL.includes(base?.user?.email);

  return (
    <Box
      sx={{
        height: "100%",
        p: 2,
        backgroundColor: "white",
        opacity: 0.9,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        boxShadow:
          "0 0 0 0.67px rgba(0, 0, 0, 0.09), 0 34px 20px rgba(0, 0, 0, 0.024)"
      }}
    >
      <Stack direction="column" alignItems="center" spacing={2}>
        <StepperCountBox stepperCount={3} text="Connect your Calendar & Zoom" />

        <BGStep3 width={"260px"} height={"inherit"} />
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1
          }}
        >
          <Typography
            variant="h6"
            component="div"
            textAlign="center"
            fontSize="16px"
          >
            {
              base.team?.isAiInsightGenerationEnabled ? "Automatically transcribe and analyze interviews.":"Automatically transcribe interviews."
            }
            
          </Typography>
          <Typography variant="body2" textAlign="center" fontSize="15px">
            Connect your calendar and zoom account to join meetings.
          </Typography>
        </Box>

        <Button
          id="connect-calendar-button"
          variant="contained"
          size="large"
          sx={{
            flexGrow: 1,
            bgcolor: "primary.main",
            color: "white",
            "&:hover": { bgcolor: "primary.dark" }
          }}
          // disabled={!isTeamMember}
          disabled={!isEmailValid}
          onClick={googleLogin}
        >
         Connect Calendar
        </Button>
      </Stack>
    </Box>
  );
}
